// Metadata associated with header image animations
// Should be renamed to 'headerAnimParams' to distinguish from static image

export const HeaderImageParams = {
  REG_01: {
    speed: 1,
    startIndex: 0,
    loop: true,
    useAnim: false,
    autoplay: false
  },
  REG_02: {
    speed: 0.3,
    startIndex: 0,
    loop: true,
    useAnim: false,
    autoplay: false
  },
  REG_03: {
    speed: 1,
    startIndex: 0,
    loop: true,
    useAnim: false,
    autoplay: false
  },
  REG_04: {
    speed: 0.25,
    startIndex: 0,
    loop: true,
    useAnim: false,
    autoplay: false
  },
  REG_05: {
    speed: 0.25,
    startIndex: 0,
    loop: true,
    useAnim: false,
    autoplay: false
  },
  REG_06: {
    speed: 0.5,
    startIndex: 0,
    loop: true,
    useAnim: false,
    autoplay: false
  },
  REG_07: {
    speed: 0.1,
    startIndex: 0,
    loop: true,
    useAnim: false,
    autoplay: false
  },
  SUCCESS: {
    speed: 1,
    startIndex: 0,
    loop: false,
    useAnim: false,
    autoplay: false
  }
};
